<template>
  <div>
    <header-base>
      <template v-slot:rightMov>
        <div class="user" v-if="dataUser">
          <a href="/" class="user__a">
            <img src="../../assets/ds-logo.png" class="user-avatar">
          </a>
          <a  @click="showBuyStars = true" class="options-icon orange">
            <icono
              class="options-icon__icon" 
              icon="mdiStarCircle" 
              :size="20"></icono>
            <span class="options-icon__text">{{ dataUser.num_stars }}</span>
          </a>
          <router-link :to="{name: 'torneos-user-mios'}" class="options-icon alert">
            <icono
              class="options-icon__icon" 
              icon="mdiTrophy" 
              :size="15"></icono>
              <span class="options-icon__tag">Mis Torneos</span>
          </router-link>
          <a class="user-avatar" @click="showMenu = !showMenu">
            <img 
              :src="getAvatar(dataUser.avatar)"
              @error="setAltImg"
              :alt="dataUser.full_name"
              class="user-avatar__img">
          </a>
          <perfil-user-menu v-show="showMenu" />
        </div>
      </template>

      <template v-slot:rightPc v-if="dataUser">
        <router-link 
          class="options-icon blue"
          :to="{name: 'torneos-user-mios'}">
          <icono
            class="options-icon__icon" 
            icon="mdiTrophy" 
            :size="20"></icono>
          <span class="options-icon__text">Mis Torneos</span>
        </router-link>
        <router-link :to="{name: 'equipos-user-mios'}" class="options-icon">
          <icono
            class="options-icon__icon" 
            icon="mdiShieldOutline" 
            :size="20"></icono>
            <!-- <span class="options-icon__tag">Mis Equipos</span> -->
        </router-link>
        <a  @click="showBuyStars = true" class="options-icon orange">
          <icono
            class="options-icon__icon" 
            icon="mdiStarCircle" 
            :size="20"></icono>
          <span class="options-icon__text">{{ dataUser.num_stars }}</span>
        </a>
        <a @click="showMenu = !showMenu" class="perfil">
          <span class="perfil__name">{{ dataUser.full_name }}</span>
          <img 
            :src="getAvatar(dataUser.avatar)"
            @error="setAltImg"
            :alt="dataUser.full_name"
            class="perfil__img">
          <perfil-user-menu v-show="showMenu" />
        </a>
      </template>
    </header-base>
    <recargar-estrellas
      v-if="showBuyStars" 
      :closeFunciton="closeBuystars"
      :num-stars="dataUser.num_stars"
    />
  </div>
</template>

<script>
  import { defineAsyncComponent } from 'vue'
  //
  import { mapGetters } from 'vuex'
  //
  // mixins
  import { notImageMixin } from '@/mixins/notImageMixin'
  //
  import VButtonMain from '@/components/base/VButtonMain.vue'
  import HeaderBase from './HeaderBase.vue'
  import PerfilUserMenu from './PerfilUserMenu.vue'
  // 
  import notImage from '@/assets/user.png'

  export default {
    name: 'HeaderMainUser',
    mixins: [notImageMixin],
    components: {
      VButtonMain,
      HeaderBase,
      PerfilUserMenu,
      RecargarEstrellas: defineAsyncComponent(() => import('@/componentshop/base/RecargarEstrellas.vue')),
    },
    computed: {
      ...mapGetters({
        dataUser: 'dataUser'
      })
    },
    data() {
      return {
        showMenu: false,
        showBuyStars: false
      }
    },
    methods: {
      getAvatar: function (image) {
        if (image) {
          return image
        } else {
          return notImage
        }
      },
      closeBuystars: function () {
        this.showBuyStars = false
      }
    },
  }
</script>

<style lang="scss" scoped>
  .user {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    &__a {
      text-decoration: none;
    }
  }
  .user-avatar {
    display: flex;
    width: 35px;
    height: 35px;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    text-decoration: none;
    &__img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
  .perfil {
    position: relative;
    display: flex;
    text-decoration: none;
    justify-content: flex-start;
    align-items: center;
    margin-left: 1em;
    margin-right: 1em;
    padding-left: 10px;
    padding-right: 10px;
    &:hover {
      border: 1px solid $color-9;
      border-radius: 5px;
      cursor: pointer;
    }
    &__name {
      font-family: $ff-1;
      font-size: 14px;
      color: $color-white;
      font-weight: bold;
      display: block;
      width: 100px; // puede ser menos o en px
      white-space: nowrap; // indica que que se muestre en una sola fila
      overflow: hidden; // la parte que se desborda no se muestra
      text-overflow: ellipsis; 
    }
    &__img {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin: 5px;
    }
  }

  .options-icon {
    display: flex;
    align-items: center;
    text-decoration: none;
    color: $color-white;
    padding: 5px 5px;
    border-radius: 10px;
    margin-right: 5px;
    &.alert {
      border: 1px solid;
    }
    @include desde ($medium) {
      margin: 1px 5px;
      padding: 7px 10px;
    }
    &__text {
      margin-left: 5px;
      display: inline;
    }
    &__tag {
      font-size: 12px;
      margin-left: 5px;
      @include desde ($medium) {
        font-size: 14px;
        margin-left: 7px;
      }
      &:hover {
        text-decoration: underline;
      }
    }
    &__icon {
      color: $color-white;
      margin-bottom: -3px;
      &:hover {
        border-bottom: 1px solid $color-white;
      }
    }
    &.blue {
      background: $color-6;
      padding-left: 20px;
      padding-right: 20px;
    }
    &.orange {
      background: $color-5;
      padding-left: 20px;
      padding-right: 20px;
      font-family: $ff-4;
      @include desde($large) {
        font-size: 17px;
      }
      &:hover {
        cursor: pointer;
      }
    }
  }
</style>